<!--普通卷-->
<template>
  <div class="doExam" v-loading.fullscreen="commitStatus">
    <div id="my-calculator" style="display: none;"></div>
    <div class="headerTop">
      <div class="infoNav">
        <img src="@/assets/images/doExam/pic.jpg" width="75" height="95" class="fl">
        <ul class="fl">
          <li>姓 名：{{userName}}</li>
          <li>性 别：X</li>
          <li>准考证号：11111111111</li>
          <li>证件号码: 111111111111111111</li>
        </ul>
      </div>
      <div class="fr count-down">
        <!--答题区倒计时-->
        <timer v-if="endTimes>0" :end-times.sync="endTimes"/>
        <a href="javascript:void (0)" @click="handOverFn" class="submitbutton">交卷</a>
        <a href="javascript:void (0)" @click="tempCommit" class="submitbutton">保存</a>
      </div>
      <div class="tit">{{courseName}}</div>
    </div>

    <div class="exam-main">
      <div class="fl" :style="{width: slideStatus ? '15px':'315px'}">
        <div class="aside-main fl" v-if="!slideStatus">
          <exam-ques-list @quesFn="changeByQueList"></exam-ques-list>
          <div class="aside-info">
            <p>说明：</p>
            <p>1.题号右边的“*”符号代表该小题尚未作答</p>
            <p>2.题号右边的“?”符号代表该小题做过标记</p>
            <p>3.考生作答的同时会自动保存答案</p>
          </div>
          <div class="aside-calc" @click="runCalc"/>
        </div>
        <div class="aside-show left">
          <img v-if="slideStatus" src="@/assets/images/doExam/open.gif" @click="slideStatus=!slideStatus">
          <img v-else src="@/assets/images/doExam/close.gif" @click="slideStatus=!slideStatus">
        </div>
      </div>
      <div class="fl rightCon">
        <div v-if="quesTypeShowMap && quesTypeShowMap[currentQuestion.relOrder]"
          class="explain"
          v-show="visibleInfo">
          {{quesTypeShowMap[currentQuestion.relOrder].showSerialNum}}、
          {{quesTypeShowMap[currentQuestion.relOrder].viewTypeName}}
          {{quesTypeShowMap[currentQuestion.relOrder].quesTypeDesc?'('+quesTypeShowMap[currentQuestion.relOrder].quesTypeDesc+')':''}}
        </div>
        <div class="ques-container">

          <!--不显示试卷试题序号，只显示当前题序号2021/9/29-->
          <!--<strong class="serialNum" v-if="currentQuestion.quesTypeID ===1 || currentQuestion.quesTypeID === 3 || currentQuestion.quesTypeID === 2">第{{currentQuestion.serialNum}}题</strong>-->
          <!-- 单选题、判断题 -->
          <template v-if="currentQuestion.quesTypeID === 1 || currentQuestion.quesTypeID === 3">
            <exam-single-choice @runCalc="runCalc"/>
          </template>
          <!-- 多选题 -->
          <template v-if="currentQuestion.quesTypeID === 2">
            <exam-multiple-choice @runCalc="runCalc"/>
          </template>
          <!-- 简答题、综合题、计算分析题(大题套小题，文字题) -->
          <template v-if="currentQuestion.quesTypeID === 4 || currentQuestion.quesTypeID === 5">
            <!-- 包含子题目 -->
            <template v-if="currentQuestion.smallContent && currentQuestion.smallContent.length > 0">
              <has-child-question
                  ref="hasChildQuestion"
                  @runCalc="runCalc"
                  @setCurrentSmallContentFn="setCurrentSmallContentFn">
                  <!-- <template v-slot:header-num>
                      <strong>第{{currentQuestion.serialNum}}题</strong>
                  </template> -->
                  <template v-slot:header-func>
                    <a @click="visibleInfo=!visibleInfo">
                      <img src="@/assets/images/doExam/sqtx.gif" v-if="visibleInfo" alt="">
                      <img src="@/assets/images/doExam/zktx.gif" v-else alt="">
                    </a>
                  </template>
                </has-child-question>
            </template>
            <!-- 不包含子题目 -->
            <template v-else>
                <without-child-question
                  ref="withoutChildQuestion"
                  @runCalc="runCalc"
                  @setCurrentSmallContentFn="setCurrentSmallContentFn">
                  <!-- <template v-slot:header-num>
                      <strong>第{{currentQuestion.serialNum}}题</strong>
                  </template> -->
                  <template v-slot:header-func>
                    <a @click="visibleInfo=!visibleInfo">
                      <img src="@/assets/images/doExam/sqtx.gif" v-if="visibleInfo" alt="">
                      <img src="@/assets/images/doExam/zktx.gif" v-else alt="">
                    </a>
                  </template>
                </without-child-question>
              </template>
          </template>
        </div>

        <div class="bottomBtns">
          <!--底部按钮-->
          <input type="checkbox" :checked="currentQuestion.isMark" :value="1" @click="markToggleFn">标记
          <a
            href="javascript:void (0)"
            @click="changeQues('prev')"
            :class="[{ preDisabled: preDisabled }, 'preBtn']"
            :disabled="preDisabled"
          >上一题</a>
          <a
            href="javascript:void (0)"
            @click="changeQues('next')"
            :class="[{ nextDisabled: nextDisabled }, 'nextBtn']"
            :disabled="nextDisabled"
          >下一题 </a>
        </div>

      </div>
    </div>

    <exam-end
        :visible.sync="endExamFlag"
        :isHaveSubjective="false"
        @viewResults="viewResults"/>
    <ten-minutes :visible.sync="tenMinutesFlag" ></ten-minutes>

    <submit-alert
        :visible.sync="visibleAlert"
        :course="courseName"
        :multi-status.sync="multiStatus"
        @submit="endToSave"></submit-alert>
  </div>
</template>
<script>
  import { parseNumber, getCookie,LoadingOptions } from "@/utils"
  import mixin from './mixin/activityOrdinary'
  import examEnd from '../components/examEnd'
  import {
    Timer,
    ExamSingleChoice,
    ExamMultipleChoice,
    ExamQuesList,
    hasChildQuestion,
    withoutChildQuestion,
    tenMinutes,
    submitAlert
  } from '@components/exam'
  import { checkPaperViewIsDoneActivityReq, dealMyChanceWG } from "@api/activity";

  window._calc_element = 'my-calculator'

  export default {
    name: 'OrdinaryExam',
    mixins: [mixin],
    components: {
      Timer,
      ExamSingleChoice,
      ExamMultipleChoice,
      ExamQuesList,
      hasChildQuestion,
      withoutChildQuestion,
      examEnd,
      tenMinutes,
      submitAlert
    },
    data() {
      return {
        //常规参数
        flag: 'activityOrdinary',
        siteCourseID: '',
        temp: 1,
        bizID: '',
        spendTime: 0,
        courseID: '',
        source: 'activityPaper',
        saveBizID: '',
        uid: '',
        centerID: '', // 收费普通卷有
        //基础参数
        examName: '',
        isStart: false,
        courseName: '', //课程名称
        endTimes: 3600,
        timer: null, //计时器
        visibleAlert:false,//提交试卷弹框
        endExamFlag: false,  //结束考试弹框
        tenMinutesFlag: false, //十分钟倒计时弹框
        visibleSub: false,//主观题评分弹框
        //isHaveSubjective:true,//是否含有主观题
        alertWindow: {
          // 交卷弹窗
          show: false,
          courseName: '',
          unAnswerCount: 0,
          allQuestions: 0,
          isMultipleSelection: false  //是否多选题只选了一个答案
        },
        questionsMap: [],
        // isShowProposal: false,        //是否显示建议
        // isShowAnswerQuestion: false,  //是否显示答疑
        // isShowAnswer: false,          //是否显示答案项
        // isAnswerShow: false,          //是否显示答案
        // isShowQzSeat: false,          //是否显示题目位置
        // isShowCollect: false,         //是否显示收藏
        // isShowPointAssessment: false, //是否显示知识点考核
        // isShowVideoExplain: false,    //是否显示视频讲解
        // faqlUrl: '' ,                  //答疑跳转地址
        isTemp: false,
        userName:'',
        commitStatus: false, // 提交接口 执行状态
        slideStatus:false,
        multiStatus:false, //alert组件是否显示多选提示
        visibleInfo: true, //题目显隐
        stage: 0,// 0预约 1一模(普通卷) 2二模(普通卷) 3三模(普通卷) 10自由模(随机卷)
        activityID: 0,
        activityNo: '',// 主库活动开关标识
        sequence:0 //闯关赛的关卡信息
      }
    },
    watch: {
      endTimes(newVal) {
        document.title = this.timeFilter(newVal)
        if (newVal === 600) {
          this.tenMinutesFlag = true
        }
        if(newVal === 15){
          clearInterval(this.timer)
        }
        if (!this.endExamFlag && newVal === 0) {
          this.endToSubmit()
        }
      }
    },
    async mounted() {
      if (!this.checkLogin()) {
        return
      }
      const {
        siteCourseID,
        temp = 1,
        bizID = '',
        spendTime = 0,
        courseID,
        paperViewId = '',
        centerID,
        stage,
        activityID,
        activityNo,
        sequence
      } = this.$route.query
      this.siteCourseID = parseNumber(siteCourseID)
      this.temp = parseNumber(temp)
      this.bizID = parseNumber(bizID)
      this.stage = parseNumber(stage)
      this.spendTime = spendTime
      this.courseID = parseNumber(courseID)
      this.activityID = parseNumber(activityID)
      if(this.courseID === 276) this.isShowTable = true
      this.saveBizID = parseNumber(paperViewId)
      this.uid = parseNumber(getCookie('cdeluid') || '')
      this.userName = getCookie('username') || ''
      // 收费题库普通卷进入传递centerID然后组卷传递回来
      this.centerID = centerID ? parseNumber(centerID) : ''
      this.activityNo = activityNo
      this.sequence = parseNumber(sequence)
      //检查体力值
      this.delPhysical()

      await this.initExam()
      //计算器实例化
      this.$nextTick(() => {
        window.SetCalcType()
      })
    },
    methods:{
      async delPhysical(){
        let params = {
          type:parseInt(this.courseID), //36中级会计实务，4财务管理，3经济法
          activityNo: this.activityNo,  //活动编号
          uid: getCookie('cdeluid'),
          cmd: 1,  //cmd=1扣减，=2返还
          sequence: parseInt(this.sequence)
        }

        // todo 开发阶段暂不添加此处逻辑
        const res = await dealMyChanceWG(params)
        /*if(res == 0){
          window.name = "challengeSubmit"
          // window.location.href = '//www.chinaacc.com/zhongjizhicheng/zhuanti/dati/'
          window.location.href = `//www.chinaacc.com/zhongjizhicheng/zhuanti/dati/?courseID=${this.courseID}`
        }*/
      }
    }
  }
</script>
<style lang="scss" scoped>
</style>
